import React, { Component } from 'react';
import { Row, Col, Card, Icon, Tooltip, Modal, List, Alert, Button, Tag } from "antd";
import axios from "axios";
import numeral from "numeral";
import Colors from '../utils/Colors';
import moment from "moment-timezone";
import { getUsuario, getTipoUsuario, getTemPermissao, removeToken, removePermissoes } from "../utils/LoginManager";
import LogaFastGestor from '../imagens/1-Transparente.png';
import AssinaturaDrawer from "../components/AssinaturaDrawer";

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as TooltipChart,
    Legend,
    ResponsiveContainer
} from "recharts";

const styles = {
    page: {
        padding: 15,
        background: '#f3f3f3',
        minHeight: '100vh'
    },

    headerCard: {
        borderRadius: 10,
        marginBottom: 15,
        border: '1px solid #e8e8e8'
    },

    headerTitle: {
        fontSize: 24,
        fontWeight: 'bold',
        color: Colors.primaryDark,
        marginBottom: 4
    },

    headerSubtitle: {
        fontSize: 14,
        color: '#777'
    },

    headerRightLabel: {
        fontSize: 13,
        color: '#888'
    },

    headerRightValue: {
        fontSize: 15,
        fontWeight: 'bold',
        color: Colors.primaryDark
    },

    kpiCard: {
        borderRadius: 10,
        minHeight: 125,
        border: '1px solid #e8e8e8'
    },

    kpiIconBox: {
        width: 42,
        height: 42,
        borderRadius: 8,
        background: '#eef7f8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 8
    },

    kpiTitle: {
        fontSize: 13,
        color: '#777',
        fontWeight: 'bold',
        marginBottom: 5
    },

    kpiValue: {
        fontSize: 24,
        fontWeight: 'bold',
        color: Colors.primaryDark,
        lineHeight: '28px'
    },

    kpiSub: {
        fontSize: 12,
        color: '#999',
        marginTop: 5
    },

    sectionCard: {
        borderRadius: 10,
        marginTop: 15,
        border: '1px solid #e8e8e8'
    },

    sectionTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: Colors.primaryDark
    },

    alertItem: {
        marginBottom: 8
    },

    listValue: {
        fontWeight: 'bold',
        color: Colors.primaryDark,
        marginLeft: 10,
        whiteSpace: 'nowrap'
    },

    listPercent: {
        fontWeight: 'bold',
        color: Colors.primaryLight,
        marginLeft: 10,
        whiteSpace: 'nowrap'
    },

    emptyBox: {
        textAlign: 'center',
        color: '#999',
        padding: 25
    }
};

export default class HomePage extends Component {

    state = {
        usuario: null,
        tipoUsuario: null,

        mesAtual: '',
        anoAtual: '',
        mesAtualDescricao: '',
        ultimoAcesso: '',

        qtdeProdutos: 0,
        qtdeClientes: 0,
        qtdeVendedores: 0,
        qtdeEstoqueBaixo: 0,
        qtdeNotasPendentes: 0,

        qtdeVendas: 0,
        qtdePedidos: 0,
        qtdeOrcamentos: 0,
        qtdeOS: 0,

        vlrVendasHoje: 0,
        qtdeVendasHoje: 0,

        vlrVendasMes: 0,
        qtdeVendasMes: 0,

        vlrVendasAno: 0,
        qtdeVendasAno: 0,

        vlrSaldoAnterior: 0,
        vlrRecebidosHoje: 0,
        vlrPagosHoje: 0,
        vlrResultado: 0,

        ctasReceber: 0,
        ctasPagar: 0,
        provisao: 0,

        ctasReceberVenc: 0,
        ctasPagarVenc: 0,
        provisaoVenc: 0,

        giroEstoque: 0,

        ticketMedio: 0,
        percentualMeta: 0,
        metaMes: 0,
        percInadimplencia: 0,

        contrato: [],
        mensalidade: [],

        qtdeContratos: 0,
        qtdeContratosBloq: 0,
        qtdeContratosAbertos: 0,
        vlrContratosAbertos: 0,
        qtdeContratosPagos: 0,
        vlrContratosPagos: 0,

        listaCaixasMeses: [],
        listaVendasMeses: [],

        listaClientes: [],
        listaClientesRetorno: [],
        listaProdutos: [],

        listaVendasDocsHoje: [],
        listaVendasDocsMes: [],

        mostraDashBoard: false,
        carregando: false,
    }

    componentDidMount() {
        this.verificaSessaoAtiva();

        const usuario = getUsuario();

        getTipoUsuario().then(tipoUsuario => {
            this.setState({
                usuario,
                tipoUsuario,
                mostraDashBoard: getTemPermissao('HomeDashBoardPage', 'cons'),
            }, this.atualizarDashboard);
        });
    }

    verificaSessaoAtiva = () => {
        setTimeout(() => {
            axios
                .post('/usuarios/validaSessionLogin')
                .then(response => {
                    if (response.data) {
                        Modal.info({
                            title: 'Atenção!',
                            content: 'Usuário desconectado. A quantidade de usuários conectados excedeu seu limite'
                        });

                        removeToken();
                        removePermissoes();
                        this.props.history.push("/login");
                    }
                })
                .catch(error => {
                    console.error(error.response);
                    this.setState({
                        carregando: false,
                    });
                });

            this.verificaSessaoAtiva();
        }, 120000);
    }

    atualizarDashboard = () => {
        this.setState({
            carregando: true,

            mesAtual: '',
            anoAtual: '',
            mesAtualDescricao: '',
            qtdeProdutos: 0,
            qtdeClientes: 0,
            qtdeVendedores: 0,
            qtdeEstoqueBaixo: 0,
            qtdeNotasPendentes: 0,

            qtdeVendas: 0,
            qtdePedidos: 0,
            qtdeOrcamentos: 0,
            qtdeOS: 0,

            ultimoAcesso: '',

            vlrVendasHoje: 0,
            qtdeVendasHoje: 0,

            vlrVendasMes: 0,
            qtdeVendasMes: 0,

            vlrVendasAno: 0,
            qtdeVendasAno: 0,

            vlrSaldoAnterior: 0,
            vlrRecebidosHoje: 0,
            vlrPagosHoje: 0,
            vlrResultado: 0,

            ctasReceber: 0,
            ctasPagar: 0,
            provisao: 0,

            ctasReceberVenc: 0,
            ctasPagarVenc: 0,
            provisaoVenc: 0,

            giroEstoque: 0,

            contrato: [],
            mensalidade: [],

            qtdeContratos: 0,
            qtdeContratosBloq: 0,
            qtdeContratosAbertos: 0,
            vlrContratosAbertos: 0,
            qtdeContratosPagos: 0,
            vlrContratosPagos: 0,

            listaClientes: [],
            listaClientesRetorno: [],
            listaProdutos: [],
            listaVendasDocsHoje: [],
            listaVendasDocsMes: [],
            listaCaixasMeses: [],
            listaVendasMeses: []
        });

        axios
            .get('/estoque/dashboard')
            .then(response => {
                const { data } = response;

                this.setState({
                    carregando: false,

                    anoAtual: data.anoAtual,
                    mesAtual: data.mesAtual,
                    mesAtualDescricao: data.anoAtual && data.mesAtual
                        ? moment(data.anoAtual + '-' + data.mesAtual + '-01').format("MMM") + '/' + data.anoAtual
                        : '',

                    ultimoAcesso: data.ultimoAcesso,

                    qtdeProdutos: data.qtdeProdutos || 0,
                    qtdeClientes: data.qtdeClientes || 0,
                    qtdeEstoqueBaixo: data.qtdeEstoqueBaixo || 0,
                    qtdeNotasPendentes: data.qtdeNotasPendentes || 0,

                    qtdeVendas: data.qtdeVendas || 0,
                    qtdePedidos: data.qtdePedidos || 0,
                    qtdeOrcamentos: data.qtdeOrcamentos || 0,
                    qtdeOS: data.qtdeOS || 0,

                    vlrVendasHoje: data.vlrVendasHoje || 0,
                    qtdeVendasHoje: data.qtdeVendasHoje || 0,

                    vlrVendasMes: data.vlrVendasMes || 0,
                    qtdeVendasMes: data.qtdeVendasMes || 0,

                    vlrVendasAno: data.vlrVendasAno || 0,
                    qtdeVendasAno: data.qtdeVendasAno || 0,

                    vlrSaldoAnterior: data.vlrSaldoAnterior || 0,
                    vlrRecebidosHoje: data.vlrRecebidosHoje || 0,
                    vlrPagosHoje: data.vlrPagosHoje || 0,
                    vlrResultado: data.vlrSaldoHoje || 0,

                    ctasReceber: data.ctasReceber || 0,
                    ctasPagar: data.ctasPagar || 0,
                    provisao: (data.ctasReceber || 0) - (data.ctasPagar || 0),

                    ctasReceberVenc: data.ctasReceberVenc || 0,
                    ctasPagarVenc: data.ctasPagarVenc || 0,
                    provisaoVenc: (data.ctasReceberVenc || 0) - (data.ctasPagarVenc || 0),

                    ticketMedio:
                        (data.qtdeVendasMes || 0) > 0
                            ? (data.vlrVendasMes || 0) / data.qtdeVendasMes
                            : 0,

                    metaMes: data.metaMes || 0,

                    percentualMeta:
                        (data.metaMes || 0) > 0
                            ? ((data.vlrVendasMes || 0) / data.metaMes) * 100
                            : 0,

                    percInadimplencia:
                        (data.ctasReceber || 0) > 0
                            ? ((data.ctasReceberVenc || 0) / data.ctasReceber) * 100
                            : 0,

                    giroEstoque: data.giroEstoque || 0,

                    contrato: data.contrato || [],
                    mensalidade: data.mensalidade || [],

                    qtdeContratos: data.qtdeContratos || 0,
                    qtdeContratosBloq: data.qtdeContratosBloq || 0,

                    qtdeContratosAbertos: data.qtdeContratosAbertos || 0,
                    vlrContratosAbertos: data.vlrContratosAbertos || 0,
                    qtdeContratosPagos: data.qtdeContratosPagos || 0,
                    vlrContratosPagos: data.vlrContratosPagos || 0,

                    listaCaixasMeses: data.listaCaixasMeses || [],
                    listaVendasMeses: data.listaVendasMeses || [],

                    listaClientes: data.listaClientes || [],
                    listaClientesRetorno: data.listaClientesRetorno || [],
                    listaProdutos: data.listaProdutos || [],

                    listaVendasDocsHoje: data.listaVendasDocsHoje || [],
                    listaVendasDocsMes: data.listaVendasDocsMes || [],
                });
            })
            .catch(error => {
                console.error(error.response);
                this.setState({
                    carregando: false,
                });
            });
    }

    renderValor = (vlr) => {
        return numeral(parseFloat(vlr || 0)).format('0,000.00');
    }

    renderValor4 = (vlr) => {
        return numeral(parseFloat(vlr || 0)).format('0,000.0000');
    }

    renderData = (data) => {
        if (data) {
            return moment(data).format('DD/MM/YYYY');
        }

        return '';
    }

    renderDataHora = (data) => {
        if (data) {
            return moment(data).format('DD/MM/YYYY HH:mm');
        }

        return '';
    }

    onMudaDashBoardPress = () => {
        this.setState({
            mostraDashBoard: !this.state.mostraDashBoard
        });
    }

    renderKpi = ({ titulo, valor, subtitulo, icone, cor, tipo }) => {
        return (
            <Card
                bodyStyle={{ padding: 16 }}
                style={styles.kpiCard}
            >
                <div style={styles.kpiIconBox}>
                    <Icon
                        type={icone}
                        style={{
                            fontSize: 22,
                            color: cor || Colors.primary
                        }}
                    />
                </div>

                <div style={styles.kpiTitle}>
                    {titulo}
                </div>

                <div
                    style={{
                        ...styles.kpiValue,
                        color: tipo === 'danger'
                            ? '#cf1322'
                            : tipo === 'success'
                                ? '#237804'
                                : Colors.primaryDark
                    }}
                >
                    {valor}
                </div>

                {subtitulo ? (
                    <div style={styles.kpiSub}>
                        {subtitulo}
                    </div>
                ) : null}
            </Card>
        );
    }

    getStatusGiroEstoque = () => {
        const { giroEstoque } = this.state;

        const percentual = giroEstoque * 100;

        if (percentual >= 80) {
            return {
                descricao: 'BOM',
                cor: '#52c41a',
                tipo: 'success'
            };
        }

        if (percentual >= 30) {
            return {
                descricao: 'REGULAR',
                cor: '#faad14',
                tipo: ''
            };
        }

        return {
            descricao: 'RUIM',
            cor: '#f5222d',
            tipo: 'danger'
        };
    }

    renderEmpty = (texto) => {
        return (
            <div style={styles.emptyBox}>
                {texto || 'Nenhum registro encontrado'}
            </div>
        );
    }

    renderStatusPlano = () => {
        const { anoAtual, contrato } = this.state;

        if (!anoAtual) {
            return (
                <span style={{ color: '#999', fontWeight: 'bold' }}>
                    INATIVO
                </span>
            );
        }

        if (contrato && contrato.contr_bloqueio === 1) {
            return (
                <span style={{ color: '#cf1322', fontWeight: 'bold' }}>
                    BLOQUEADO EM {this.renderData(contrato.contr_data_bloqueio)}
                </span>
            );
        }

        if (contrato && contrato.contr_situacao === 0) {
            return (
                <span style={{ color: '#cf1322', fontWeight: 'bold' }}>
                    CANCELADO EM {this.renderData(contrato.contr_data_cancelamento)}
                </span>
            );
        }

        if (
            contrato &&
            (contrato.contr_data_contratado === '' || contrato.contr_data_contratado === null)
        ) {
            return (
                <span style={{ color: '#fa8c16', fontWeight: 'bold' }}>
                    PERÍODO DE TESTES
                </span>
            );
        }

        return (
            <span style={{ color: '#237804', fontWeight: 'bold' }}>
                ATIVO
            </span>
        );
    }







    renderDashboard = () => {
        const {
            usuario,
            ultimoAcesso,

            qtdeProdutos,
            qtdeClientes,
            qtdeEstoqueBaixo,
            qtdeNotasPendentes,

            qtdeVendas,
            qtdePedidos,
            qtdeOrcamentos,
            qtdeOS,

            vlrVendasHoje,
            qtdeVendasHoje,
            vlrVendasMes,
            qtdeVendasMes,
            vlrVendasAno,
            qtdeVendasAno,

            vlrSaldoAnterior,
            vlrRecebidosHoje,
            vlrPagosHoje,
            vlrResultado,

            ctasReceber,
            ctasPagar,
            provisao,

            ctasReceberVenc,
            ctasPagarVenc,
            provisaoVenc,

            contrato,
            mensalidade,

            qtdeContratos,
            qtdeContratosBloq,
            qtdeContratosAbertos,
            vlrContratosAbertos,
            qtdeContratosPagos,
            vlrContratosPagos,

            anoAtual,
            mesAtualDescricao,

            listaClientes,
            listaClientesRetorno,
            listaProdutos,
            listaVendasMeses,
            listaCaixasMeses,

            ticketMedio,
            percentualMeta,
            metaMes,
            percInadimplencia,
            giroEstoque,

        } = this.state;


        const statusGiro =
            this.getStatusGiroEstoque();

        const nomeUsuario = usuario && usuario.usu_nome
            ? usuario.usu_nome
            : usuario && usuario.nome
                ? usuario.nome
                : '';

        return (
            <div style={styles.page}>

                <Card
                    style={styles.headerCard}
                    bodyStyle={{ padding: 20 }}
                >
                    <Row gutter={16} type="flex" align="middle">
                        <Col xs={24} md={14}>
                            <div style={styles.headerTitle}>
                                Olá{nomeUsuario ? ', ' + nomeUsuario : ''}
                            </div>

                            <div style={styles.headerSubtitle}>
                                Acompanhe os principais indicadores da empresa em um único painel.
                            </div>
                        </Col>

                        <Col xs={24} md={10} style={{ textAlign: 'right' }}>
                            <div style={styles.headerRightLabel}>
                                Último acesso
                            </div>

                            <div style={styles.headerRightValue}>
                                {this.renderDataHora(ultimoAcesso) || 'Não informado'}
                            </div>

                            <Button
                                htmlType="button"
                                onClick={this.atualizarDashboard}
                                style={{
                                    marginTop: 10,
                                    backgroundColor: Colors.primaryLight,
                                    borderColor: Colors.primaryLight,
                                    color: '#fff',
                                }}
                            >
                                <Icon type="reload" />
                                Atualizar dashboard
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Row gutter={12}>
                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Vendas Hoje',
                            valor: 'R$ ' + this.renderValor(vlrVendasHoje),
                            subtitulo: qtdeVendasHoje + ' venda(s)',
                            icone: 'shopping-cart',
                            cor: Colors.primary,
                            tipo: 'success'
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Vendas Mês',
                            valor: 'R$ ' + this.renderValor(vlrVendasMes),
                            subtitulo: qtdeVendasMes + ' venda(s)',
                            icone: 'bar-chart',
                            cor: Colors.primary
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Caixa Atual',
                            valor: 'R$ ' + this.renderValor(vlrResultado),
                            subtitulo: 'Saldo do dia',
                            icone: 'wallet',
                            cor: '#237804',
                            tipo: vlrResultado < 0 ? 'danger' : 'success'
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'À Receber',
                            valor: 'R$ ' + this.renderValor(ctasReceber),
                            subtitulo: 'Total pendente',
                            icone: 'arrow-down',
                            cor: '#237804',
                            tipo: 'success'
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'À Pagar',
                            valor: 'R$ ' + this.renderValor(ctasPagar),
                            subtitulo: 'Total pendente',
                            icone: 'arrow-up',
                            cor: '#cf1322',
                            tipo: ctasPagar > ctasReceber ? 'danger' : ''
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Resultado',
                            valor:
                                'R$ ' +
                                this.renderValor(
                                    ctasReceber - ctasPagar
                                ),
                            subtitulo: 'Receber - Pagar',
                            icone: 'calculator',
                            cor:
                                (ctasReceber - ctasPagar) >= 0
                                    ? '#52c41a'
                                    : '#f5222d',
                            tipo:
                                (ctasReceber - ctasPagar) >= 0
                                    ? 'success'
                                    : 'danger'
                        })}
                    </Col>
                </Row>

                <Row gutter={12}>
                    <Col xs={24} sm={12} md={6} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Vendas Ano ' + anoAtual,
                            valor: 'R$ ' + this.renderValor(vlrVendasAno),
                            subtitulo: qtdeVendasAno + ' venda(s)',
                            icone: 'line-chart',
                            cor: Colors.primary
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={6} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Clientes',
                            valor: qtdeClientes,
                            subtitulo: 'cadastrados',
                            icone: 'team',
                            cor: Colors.primary
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={6} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Produtos',
                            valor: qtdeProdutos,
                            subtitulo: 'cadastrados',
                            icone: 'barcode',
                            cor: Colors.primary
                        })}
                    </Col>

                    <Col xs={24} sm={12} md={6} style={{ marginBottom: 12 }}>
                        {this.renderKpi({
                            titulo: 'Notas Pendentes',
                            valor: qtdeNotasPendentes,
                            subtitulo: 'nota(s)',
                            icone: 'file-exclamation',
                            cor: '#fa8c16',
                            tipo: qtdeNotasPendentes > 0 ? 'danger' : 'success'
                        })}
                    </Col>
                </Row>


                <Row gutter={12}>

                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: 12 }}
                    >
                        {this.renderKpi({
                            titulo: 'Ticket Médio',
                            valor:
                                'R$ ' +
                                this.renderValor(ticketMedio),
                            subtitulo: 'Venda média',
                            icone: 'shopping',
                            cor: '#1890ff'
                        })}
                    </Col>

                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: 12 }}
                    >
                        {this.renderKpi({
                            titulo: 'Inadimplência',
                            valor:
                                percInadimplencia.toFixed(1) + '%',
                            subtitulo:
                                'Contas vencidas',
                            icone: 'exclamation-circle',
                            cor:
                                percInadimplencia > 10
                                    ? '#f5222d'
                                    : '#52c41a',
                            tipo:
                                percInadimplencia > 10
                                    ? 'danger'
                                    : 'success'
                        })}
                    </Col>

                    <Col
                        xs={24}
                        sm={12}
                        md={8}
                        style={{ marginBottom: 12 }}
                    >
                        {this.renderKpi({
                            titulo: 'Giro Estoque',
                            valor: statusGiro.descricao,
                            subtitulo:
                                (giroEstoque * 100).toFixed(2) +
                                '% • Últimos 30 dias',
                            icone: 'reload',
                            cor: '#722ed1',
                            tipo: statusGiro.tipo
                        })}
                    </Col>

                </Row>


                <Row gutter={12}>
                    <Col xs={24} md={8}>
                        <Card
                            title={<span style={styles.sectionTitle}>Alertas</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 15, textAlign: 'left', minHeight: 320 }}
                        >
                            {qtdeNotasPendentes > 0 ? (
                                <Alert
                                    style={styles.alertItem}
                                    message={qtdeNotasPendentes + ' nota(s) pendente(s) de emissão'}
                                    type="warning"
                                    showIcon
                                />
                            ) : null}

                            {ctasReceberVenc > 0 ? (
                                <Alert
                                    style={styles.alertItem}
                                    message={'R$ ' + this.renderValor(ctasReceberVenc) + ' vencidos para receber'}
                                    type="error"
                                    showIcon
                                />
                            ) : null}

                            {ctasPagarVenc > 0 ? (
                                <Alert
                                    style={styles.alertItem}
                                    message={'R$ ' + this.renderValor(ctasPagarVenc) + ' vencidos para pagar'}
                                    type="error"
                                    showIcon
                                />
                            ) : null}

                            {qtdeEstoqueBaixo > 0 ? (
                                <Alert
                                    style={styles.alertItem}
                                    message={qtdeEstoqueBaixo + ' produto(s) abaixo do estoque mínimo'}
                                    type="warning"
                                    showIcon
                                />
                            ) : null}

                            {
                                qtdeEstoqueBaixo > 0 && (
                                    <Alert
                                        style={styles.alertItem}
                                        message={
                                            qtdeEstoqueBaixo +
                                            ' produto(s) abaixo do mínimo'
                                        }
                                        type="warning"
                                        showIcon
                                    />
                                )
                            }

                            {qtdeNotasPendentes <= 0 &&
                                ctasReceberVenc <= 0 &&
                                ctasPagarVenc <= 0 &&
                                qtdeEstoqueBaixo <= 0 ? (
                                <Alert
                                    message="Nenhum alerta importante no momento"
                                    type="success"
                                    showIcon
                                />
                            ) : null}
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card
                            title={<span style={styles.sectionTitle}>Resumo Operacional</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 15, textAlign: 'left' }}
                        >
                            <List>
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="shopping" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Vendas"
                                        description="Total cadastrado"
                                    />
                                    <div style={styles.listValue}>{qtdeVendas}</div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="file-text" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Pedidos"
                                        description="Total cadastrado"
                                    />
                                    <div style={styles.listValue}>{qtdePedidos}</div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="profile" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Orçamentos"
                                        description="Total cadastrado"
                                    />
                                    <div style={styles.listValue}>{qtdeOrcamentos}</div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="tool" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Ordens de Serviço"
                                        description="Total cadastrado"
                                    />
                                    <div style={styles.listValue}>{qtdeOS}</div>
                                </List.Item>
                            </List>
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card
                            title={<span style={styles.sectionTitle}>Resumo Financeiro</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 15, textAlign: 'left' }}
                        >
                            <List>
                                <List.Item>
                                    <List.Item.Meta
                                        title="Saldo Anterior"
                                        description="Saldo antes das movimentações de hoje"
                                    />
                                    <div style={styles.listValue}>
                                        R$ {this.renderValor(vlrSaldoAnterior)}
                                    </div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        title="Recebido Hoje"
                                        description="Entradas do dia"
                                    />
                                    <div style={{ ...styles.listValue, color: '#237804' }}>
                                        R$ {this.renderValor(vlrRecebidosHoje)}
                                    </div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        title="Pago Hoje"
                                        description="Saídas do dia"
                                    />
                                    <div style={{ ...styles.listValue, color: '#cf1322' }}>
                                        R$ {this.renderValor(vlrPagosHoje)}
                                    </div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        title="Provisão"
                                        description="À receber - à pagar"
                                    />
                                    <div
                                        style={{
                                            ...styles.listValue,
                                            color: provisao < 0 ? '#cf1322' : '#237804'
                                        }}
                                    >
                                        R$ {this.renderValor(provisao)}
                                    </div>
                                </List.Item>
                            </List>
                        </Card>
                    </Col>
                </Row>

                <Row gutter={12}>
                    <Col xs={24} md={12}>
                        <Card
                            title={<span style={styles.sectionTitle}>Contas Vencidas</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 15, textAlign: 'left' }}
                        >
                            <List>
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="arrow-down" style={{ fontSize: 22, color: '#237804' }} />}
                                        title="Valor vencido à receber"
                                        description="Títulos vencidos de clientes"
                                    />

                                    <div style={{ ...styles.listValue, color: '#cf1322' }}>
                                        R$ {this.renderValor(ctasReceberVenc)}
                                    </div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="arrow-up" style={{ fontSize: 22, color: '#cf1322' }} />}
                                        title="Valor vencido à pagar"
                                        description="Títulos vencidos de fornecedores/despesas"
                                    />

                                    <div style={{ ...styles.listValue, color: '#cf1322' }}>
                                        R$ {this.renderValor(ctasPagarVenc)}
                                    </div>
                                </List.Item>

                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="calculator" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Provisão vencida"
                                        description="Receber vencido - pagar vencido"
                                    />

                                    <div
                                        style={{
                                            ...styles.listValue,
                                            color: provisaoVenc < 0 ? '#cf1322' : '#237804'
                                        }}
                                    >
                                        R$ {this.renderValor(provisaoVenc)}
                                    </div>
                                </List.Item>
                            </List>
                        </Card>
                    </Col>

                    <Col xs={24} md={12}>
                        <Card
                            title={<span style={styles.sectionTitle}>Plano / Assinatura</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 15, paddingBottom: 45, textAlign: 'left' }}
                        >
                            <List>
                                <List.Item>
                                    <List.Item.Meta
                                        avatar={<Icon type="safety-certificate" style={{ fontSize: 22, color: Colors.primary }} />}
                                        title="Situação do plano"
                                        description="Status atual da assinatura"
                                    />

                                    <div style={styles.listValue}>
                                        {this.renderStatusPlano()}
                                    </div>
                                </List.Item>

                                {mensalidade && mensalidade.tparc_data_parcela ? (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<Icon type="calendar" style={{ fontSize: 22, color: Colors.primary }} />}
                                            title="Próxima mensalidade"
                                            description={
                                                mensalidade.situacao_parcela === 'ABERTO'
                                                    ? 'Em aberto'
                                                    : mensalidade.situacao_parcela
                                            }
                                        />

                                        <div style={styles.listValue}>
                                            {this.renderData(mensalidade.tparc_data_parcela)}
                                            {' - R$ '}
                                            {this.renderValor(mensalidade.tparc_valor)}
                                        </div>
                                    </List.Item>
                                ) : null}

                                {contrato && contrato.contr_data_vencimento ? (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<Icon type="clock-circle" style={{ fontSize: 22, color: Colors.primary }} />}
                                            title="Validade do plano"
                                            description="Data de vencimento"
                                        />

                                        <div style={styles.listValue}>
                                            {this.renderData(contrato.contr_data_vencimento)}
                                        </div>
                                    </List.Item>
                                ) : null}

                                {qtdeContratos ? (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<Icon type="switcher" style={{ fontSize: 22, color: Colors.primary }} />}
                                            title="Contratos"
                                            description={
                                                'Bloqueados: ' + qtdeContratosBloq
                                            }
                                        />

                                        <div style={styles.listValue}>
                                            {qtdeContratos}
                                        </div>
                                    </List.Item>
                                ) : null}

                                {qtdeContratos ? (
                                    <List.Item>
                                        <List.Item.Meta
                                            title="Contratos pagos"
                                            description={qtdeContratosPagos + ' contrato(s)'}
                                        />

                                        <div style={styles.listValue}>
                                            R$ {this.renderValor(vlrContratosPagos)}
                                        </div>
                                    </List.Item>
                                ) : null}

                                {qtdeContratos ? (
                                    <List.Item>
                                        <List.Item.Meta
                                            title="Contratos em aberto"
                                            description={qtdeContratosAbertos + ' contrato(s)'}
                                        />

                                        <div style={styles.listValue}>
                                            R$ {this.renderValor(vlrContratosAbertos)}
                                        </div>
                                    </List.Item>
                                ) : null}
                            </List>

                            <div style={{ marginTop: 35 }}>
                                <AssinaturaDrawer
                                    mensalidade={mensalidade}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>

                <Row gutter={12}>
                    <Col xs={24} lg={12}>
                        <Card
                            title={<span style={styles.sectionTitle}>Evolução das Vendas</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 10 }}
                        >
                            {listaVendasMeses && listaVendasMeses.length > 0 ? (
                                <ResponsiveContainer width="100%" height={280}>
                                    <BarChart
                                        data={listaVendasMeses}
                                        margin={{
                                            top: 10,
                                            right: 10,
                                            left: 15,
                                            bottom: 0
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />

                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 11 }}
                                        />

                                        <YAxis
                                            width={55}
                                            tick={{ fontSize: 11 }}
                                            tickFormatter={(tick) =>
                                                numeral(tick).format('0a')
                                            }
                                        />

                                        <TooltipChart
                                            formatter={(value) =>
                                                'R$ ' + this.renderValor(value)
                                            }
                                        />

                                        <Legend
                                            wrapperStyle={{
                                                fontSize: 12
                                            }}
                                        />

                                        <Bar
                                            dataKey="vendas"
                                            name="Vendas"
                                            fill={Colors.primary}
                                            barSize={22}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            ) : (
                                this.renderEmpty('Nenhuma venda encontrada')
                            )}
                        </Card>
                    </Col>

                    <Col xs={24} lg={12}>
                        <Card
                            title={<span style={styles.sectionTitle}>Fluxo Financeiro</span>}
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 10 }}
                        >
                            {listaCaixasMeses && listaCaixasMeses.length > 0 ? (
                                <ResponsiveContainer width="100%" height={280}>
                                    <BarChart
                                        data={listaCaixasMeses}
                                        margin={{
                                            top: 10,
                                            right: 10,
                                            left: 15,
                                            bottom: 0
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />

                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 11 }}
                                        />

                                        <YAxis
                                            width={55}
                                            tick={{ fontSize: 11 }}
                                            tickFormatter={(tick) =>
                                                numeral(tick).format('0a')
                                            }
                                        />

                                        <TooltipChart
                                            formatter={(value) =>
                                                'R$ ' + this.renderValor(value)
                                            }
                                        />

                                        <Legend
                                            wrapperStyle={{
                                                fontSize: 12
                                            }}
                                        />

                                        <Bar
                                            dataKey="ent"
                                            name="Entradas"
                                            fill="#52c41a"
                                            barSize={14}
                                        />

                                        <Bar
                                            dataKey="sai"
                                            name="Saídas"
                                            fill="#ff4d4f"
                                            barSize={14}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            ) : (
                                this.renderEmpty('Nenhuma movimentação financeira encontrada')
                            )}
                        </Card>
                    </Col>
                </Row>

                <Row gutter={12}>
                    <Col xs={24} md={8}>
                        <Card
                            title={
                                <Tooltip title="Melhores Clientes dos últimos meses">
                                    <span style={styles.sectionTitle}>Melhores Clientes</span>
                                </Tooltip>
                            }
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 0 }}
                        >
                            {listaClientes && listaClientes.length > 0 ? (
                                <List
                                    dataSource={listaClientes.slice(0, 10)}
                                    renderItem={(item, index) => (
                                        <List.Item style={{ paddingLeft: 15, paddingRight: 15, textAlign: 'left' }}>
                                            <List.Item.Meta
                                                avatar={
                                                    <div
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            borderRadius: 14,
                                                            background: '#eef7f8',
                                                            color: Colors.primaryDark,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {index + 1}
                                                    </div>
                                                }
                                                title={item.nome}
                                                description={
                                                    item.perc
                                                        ? this.renderValor(item.perc.toFixed(2)) + '% de participação'
                                                        : '0,00% de participação'
                                                }
                                            />

                                            <div style={styles.listValue}>
                                                R$ {this.renderValor(item.valor)}
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            ) : this.renderEmpty('Nenhum cliente encontrado')}
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card
                            title={
                                <Tooltip title="Produtos/Serviços mais vendidos dos últimos meses">
                                    <span style={styles.sectionTitle}>Mais Vendidos</span>
                                </Tooltip>
                            }
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 0 }}
                        >
                            {listaProdutos && listaProdutos.length > 0 ? (
                                <List
                                    dataSource={listaProdutos.slice(0, 10)}
                                    renderItem={(item, index) => (
                                        <List.Item style={{ paddingLeft: 15, paddingRight: 15, textAlign: 'left' }}>
                                            <List.Item.Meta
                                                avatar={
                                                    <div
                                                        style={{
                                                            width: 28,
                                                            height: 28,
                                                            borderRadius: 14,
                                                            background: '#eef7f8',
                                                            color: Colors.primaryDark,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        {index + 1}
                                                    </div>
                                                }
                                                title={item.nome}
                                                description={
                                                    'Qtde: ' + this.renderValor(item.qtde || 0)
                                                }
                                            />

                                            <div style={styles.listValue}>
                                                R$ {this.renderValor(item.valor)}
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            ) : this.renderEmpty('Nenhum produto encontrado')}
                        </Card>
                    </Col>

                    <Col xs={24} md={8}>
                        <Card
                            title={
                                <Tooltip title="Clientes que podem receber contato de retorno">
                                    <span style={styles.sectionTitle}>Clientes para Retorno</span>
                                </Tooltip>
                            }
                            style={styles.sectionCard}
                            bodyStyle={{ padding: 0 }}
                        >
                            {listaClientesRetorno && listaClientesRetorno.length > 0 ? (
                                <List
                                    dataSource={listaClientesRetorno.slice(0, 10)}
                                    renderItem={(item) => (
                                        <List.Item style={{ paddingLeft: 15, paddingRight: 15, textAlign: 'left' }}>
                                            <List.Item.Meta
                                                avatar={
                                                    <Icon
                                                        type="phone"
                                                        style={{
                                                            fontSize: 22,
                                                            color: Colors.primary
                                                        }}
                                                    />
                                                }
                                                title={item.nome}
                                                description="Última compra/atendimento"
                                            />

                                            <div style={styles.listValue}>
                                                {this.renderData(item.data)}
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            ) : this.renderEmpty('Nenhum cliente para retorno')}
                        </Card>
                    </Col>
                </Row>


            </div>
        );
    }

    renderLogo = () => {
        return (
            <div style={{ align: 'center', textAlign: 'center' }}>
                <img
                    alt="FastGestor"
                    src={LogaFastGestor}
                />

                {getTemPermissao('HomeDashBoardAdminPage', 'cons') ? (
                    <div style={{ float: "right", marginTop: 25, marginRight: 30 }}>
                        <Tooltip title="DashBoard">
                            <Button
                                htmlType="button"
                                onClick={this.onMudaDashBoardPress}
                                style={{ width: "100%" }}
                                className="btn-fechar"
                            >
                                <Icon
                                    style={{
                                        fontSize: 30,
                                        color: Colors.primary
                                    }}
                                    type="appstore"
                                />
                            </Button>
                        </Tooltip>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { mostraDashBoard } = this.state;

        return mostraDashBoard
            ? this.renderDashboard()
            : this.renderLogo();
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePage.js